import i18next from 'i18next'
import * as React from 'react'
import { Link } from 'widgets-for-react'
import { DataLayer } from '../../../../utils/datalayer'
import { PictureLayout } from '../../image/imageLayout'
import { RootLayout } from '../../rootLayout'
import {
  getKnowledgeTypeSectionOfSlug,
  maybeGetKnowledgeType,
} from '../knowledgeUtils'
import { KnowledgeTeasersData } from './knowledgeTeasersState'

export type PageType = 'knowledge-type-overview' | 'search-results'

type KnowledgeTeasersLayoutProps = {
  kind: PageType
  title: string
  data: 'loading' | 'error' | KnowledgeTeasersData
}

export const KnowledgeTeasersLayout = (p: KnowledgeTeasersLayoutProps) => {
  const isOverview = p.kind === 'knowledge-type-overview'
  const isSearchResult = p.kind === 'search-results'
  const Tag = isSearchResult ? 'section' : 'li'
  return (
    <Tag
      className={`knowledge-block ${
        isSearchResult ? 'knowledge-block--search-results' : ''
      }`}
    >
      <div
        className={`knowledge-block__inner ${
          isSearchResult ? 'block__inner' : ''
        }`}
      >
        <header
          className={`knowledge-block__header ${
            isSearchResult ? 'block__header--search' : ''
          }`}
        >
          {isOverview && (
            <span
              id={p.title.toString()}
              aria-hidden="true"
              tabIndex={-1}
              className="knowledge-block__anchor"
            />
          )}
          <h2
            className="knowledge-block__title title--xs"
            dangerouslySetInnerHTML={{ __html: p.title }}
          />
        </header>

        {p.data === 'loading' ? (
          <RootLayout.Loader hasWrapper={true} showText={true} />
        ) : p.data === 'error' ? (
          <RootLayout.LoadingFailed
            text={i18next.t('common:loadingFailed', {
              entity: i18next.t('knowledge:knowledgeTitle').toLowerCase(),
            })}
          />
        ) : p.data.length > 0 ? (
          <div className="knowledge-block__content">
            <ul className="knowledge-block__list">
              {p.data.map((teaser) => {
                const knowledgeType = maybeGetKnowledgeType(
                  teaser.KnowledgeType
                )

                return (
                  knowledgeType && (
                    <li className="knowledge-item" key={teaser.Id}>
                      <Link
                        className="knowledge-item__link"
                        to={
                          i18next.language == 'en'
                            ? `/en/knowledge/${
                                getKnowledgeTypeSectionOfSlug(knowledgeType).en
                              }${teaser.Path.toLowerCase().replace('%', '')}`
                            : `/nl/kennis/${
                                getKnowledgeTypeSectionOfSlug(knowledgeType).nl
                              }${teaser.Path.toLowerCase().replace('%', '')}`
                        }
                        onClick={() =>
                          DataLayer.clickKnowledgeArticle(
                            teaser.KnowledgeType,
                            teaser.Path.substring(1)
                          )
                        }
                      >
                        <p className="knowledge-item__title text--s">
                          <span>{teaser.HeaderTitle}</span>
                        </p>
                        <div
                          className="knowledge-item__visual fit-object"
                          aria-hidden="true"
                        >
                          <PictureLayout.Img
                            extraClasses="knowledge-item__image"
                            image={teaser.TeaserImage}
                            width="56"
                            height="56"
                            lazyload
                          />
                        </div>
                      </Link>
                    </li>
                  )
                )
              })}
            </ul>
          </div>
        ) : (
          <RootLayout.EmptyState
            text={i18next.t('common:emptyState', {
              entity: i18next.t('knowledge:knowledgeTitle').toLowerCase(),
            })}
          />
        )}
      </div>
    </Tag>
  )
}
